import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { NotificationListLayer } from "../components/Notifications/NotificationListLayer";

export const NotificationsPage = () => {
  return (
    <MasterLayout>
      <NotificationListLayer />
    </MasterLayout>
  );
};
